<h2>Configuration - User Preferences</h2>

<div>
	<form [formGroup]="configForm" (ngSubmit)="onSubmit()" class="indentForm mapForm">
		<p-fieldset legend="Map" [toggleable]="true">
			<div class="form-group">
				<label for="baseMapSelect" title={{baseMapTitle}}>Basemap</label><br>
				<select id="baseMapSelect" formControlName="baseMapSelect" class="form-control" title={{baseMapTitle}} >
					<option *ngFor="let b of baseMaps" [value]="b">{{b}}</option>
				</select>
			</div>
		
			<div class="form-group">
				<label for="latitudeInput" title={{latitudeTitle}}>Latitude</label><br>
				<input type="text" id="latitudeInput" formControlName="latitude"  class="form-control" title={{latitudeTitle}} >
			</div>
			
			<div class="form-group">		
				<label for="longitudeInput" title={{longitudeTitle}}>Longitude</label><br>
				<input type="text" id="longitudeInput" formControlName="longitude" class="form-control" title={{longitudeTitle}} >
			</div>
		
			<div class="form-group">
				<label title={{zoomTitle}}>Zoom</label><br>
				<input type="text" id="zoomInput" formControlName="zoom" class="form-control" title={{zoomTitle}}> 
			</div>
		</p-fieldset>
	
		<!-- <button (click)="reset()">Reset</button>-->
		<button type="submit"  class="submitButton" [class.changesMade]="baseMapSelect.dirty||latitude.dirty||longitude.dirty||zoom.dirty" >Save Preferences</button> 
	</form>
</div>

<div class="developerGroup">
	Only for developer use:<br>
	<div class="indentForm innerDeveloperGroup" >
		<label><input type="checkbox" (click)="toggleDeveloperMode()" [ngModel]="developerMode">Developer mode</label>
		<div id="developerDetails" [ngClass]="{'hidden': !developerMode }">
			Period End Date: <input type="text" id="currentDate" [(ngModel)]="developerDate">
		</div>
		<!--
		<button disabled class='disableButton' (click)="saveDeveloperSettings()">Set</button>
		-->
		<button (click)="saveDeveloperSettings()">Set</button>
	</div>
</div>